/* ps-cart.js — drawer + AJAX cart for the Protein Swirl cloned storefront.
   Writes go through Shopify's Cart AJAX API; the drawer is then re-rendered
   through the Section Rendering API, so its markup always reflects the real
   cart rather than a client-side guess. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('[data-ps-drawer]'); }

  // Shopify namespaces section ids inside section groups
  // (sections--123__ps_cart_drawer), so read the real id off the DOM rather
  // than assuming the key used in header-group.json.
  function drawerHost() {
    var d = drawer();
    return d ? d.closest('[id^="shopify-section-"]') : null;
  }

  function drawerSectionId() {
    var host = drawerHost();
    return host ? host.id.replace('shopify-section-', '') : null;
  }

  function setOpen(open) {
    var d = drawer();
    if (!d) { if (open) window.location.href = root + 'cart'; return; }
    d.setAttribute('data-open', open ? 'true' : 'false');
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = d.querySelector('.ps-drawer__close');
      if (close) close.focus();
    }
  }

  function busy(state) {
    var d = drawer();
    if (d) d.classList.toggle('is-busy', !!state);
  }

  function setCount(n) {
    document.querySelectorAll('[data-ps-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // Re-render only the drawer section. The header is left intact so its
  // listeners and layout measurements survive; the count is patched in place.
  function refresh(open) {
    var id = drawerSectionId();
    var host = drawerHost();
    if (!id || !host) { if (open) setOpen(true); return Promise.resolve(); }

    return fetch(root + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#' + CSS.escape(host.id)) || tmp.firstElementChild;
          if (fresh) host.replaceWith(fresh);
        }
        if (open) setOpen(true);
      })
      .catch(function () { if (open) setOpen(true); });
  }

  function syncCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () { return null; });
  }

  function flash(btn, msg) {
    if (!btn) return;
    var original = btn.getAttribute('data-ps-restore') || btn.textContent;
    btn.setAttribute('data-ps-restore', original);
    btn.textContent = msg;
    setTimeout(function () { btn.textContent = btn.getAttribute('data-ps-restore'); }, 2400);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ps-cart-open]');
    if (open) { e.preventDefault(); setOpen(true); return; }

    var close = e.target.closest('[data-ps-cart-close]');
    if (close) { e.preventDefault(); setOpen(false); return; }

    var qty = e.target.closest('[data-ps-qty]');
    if (qty) {
      e.preventDefault();
      busy(true);
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(qty.dataset.psQty), quantity: Number(qty.dataset.psTo) })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); return refresh(true); })
        .catch(function () {})
        .then(function () { busy(false); });
      return;
    }

    var menu = e.target.closest('[data-ps-menu-toggle]');
    if (menu) {
      var header = menu.closest('[data-ps-header]');
      if (!header) return;
      var isOpen = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', isOpen ? 'false' : 'true');
      menu.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  // Add to cart from any cloned section's product form.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ps-cart-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    busy(true);

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          flash(btn, (res.body && res.body.description) ? res.body.description : 'Unavailable');
          return null;
        }
        return syncCount().then(function () { return refresh(true); });
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .then(function () {
        busy(false);
        if (btn) btn.removeAttribute('aria-disabled');
      });
  });

  // Quantity stepper on the product page.
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ps-step]');
    if (!step) return;
    e.preventDefault();
    var input = document.getElementById(step.dataset.psStep);
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + (parseInt(step.dataset.psDelta, 10) || 0);
    input.value = next < 1 ? 1 : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // The theme editor swaps section HTML in place; re-assert the closed state
  // so a re-render never leaves a scrim stranded over the page.
  document.addEventListener('shopify:section:load', function () { setOpen(false); });
})();
